import { memo, useState } from 'react'
import {
  BaseEdge,
  getBezierPath,
  type EdgeProps,
} from '@xyflow/react'

const EDGE_TYPE_LABELS: Record<string, string> = {
  extends: 'extends',
  feeds: 'feeds',
  unifies: 'unifies',
  'pairs-with': 'pairs with',
  'depends-on': 'depends on',
  implements: 'implements',
  supports: 'supports',
  references: 'references',
  hierarchy: '',
  'xref-direct': 'cross-ref',
  'xref-indirect': 'indirect ref',
}

interface MindMapEdgeData {
  edgeType: string
  description?: string
  bidirectional?: boolean
  dimmed?: boolean
  [key: string]: unknown
}

function MindMapEdgeComponent({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style,
  data,
  markerEnd,
}: EdgeProps) {
  const [hovered, setHovered] = useState(false)
  const d = (data || {}) as MindMapEdgeData

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  })

  const label = EDGE_TYPE_LABELS[d.edgeType] || d.edgeType || ''
  const isHierarchy = d.edgeType === 'hierarchy'

  return (
    <g
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <BaseEdge
        id={id}
        path={edgePath}
        style={{
          ...style,
          opacity: d.dimmed ? 0.1 : isHierarchy ? 0.4 : hovered ? 1 : 0.6,
          transition: 'opacity 0.2s',
        }}
        markerEnd={markerEnd}
      />
      {/* Invisible wider path for easier hover */}
      <path
        d={edgePath}
        fill="none"
        stroke="transparent"
        strokeWidth={12}
      />
      {hovered && label && !isHierarchy && (
        <foreignObject
          x={labelX - 40}
          y={labelY - 12}
          width={80}
          height={24}
          className="pointer-events-none"
        >
          <div className="flex items-center justify-center h-full">
            <span className="text-[10px] font-medium bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 px-1.5 py-0.5 rounded shadow-sm text-gray-600 dark:text-gray-300 whitespace-nowrap">
              {label}
            </span>
          </div>
        </foreignObject>
      )}
    </g>
  )
}

export const MindMapEdge = memo(MindMapEdgeComponent)
